import { GameTextUtil } from "@lib/js-slingo-fruttiboost-core/dist/game/utils/GameTextUtil";
import { GameFontStyle } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/style/GameFontStyle";
import { GameStyle } from "@lib/js-slingo-fruttiboost-core/dist/game/view/abstract/style/GameStyle";
import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { ButtonProperties } from "@lib/titan2/dist/game/control/properties/ButtonProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { AbstractPromptDialogProperties } from "@lib/titan2/dist/game/view/properties/AbstractPromptDialogProperties";
import { CommonStyle } from "@lib/titan2/dist/game/view/style/CommonStyle";
import * as PIXI from "pixi.js";
import { Point } from "pixi.js";
/**
 * PromptDialogProperties.ts
 */
export class PromptDialogProperties extends AbstractPromptDialogProperties {
    setDefaultValues() {
        super.setDefaultValues();
        const imageWidth = 836;
        const buttonSize = 377;
        const buttonEmptySize = imageWidth - 2 * buttonSize;
        const leftButtonX = buttonEmptySize / 3;
        const rightButtonX = imageWidth - leftButtonX - buttonSize;
        this.titleFieldProperties = new TextFieldProperties(GameFontStyle.DIALOG_PROMPT_TITLE, new Point(imageWidth / 2, 130), undefined, ControlConstants.CENTER, ControlConstants.CENTER, new PIXI.Point(800, 160));
        this.messageFieldProperties = new TextFieldProperties(GameFontStyle.DIALOG_PROMPT_BODY, new Point(imageWidth / 2, 440), undefined, ControlConstants.CENTER, ControlConstants.CENTER, new Point(800, 400));
        this.messageFieldProperties.multiline = true;
        GameTextUtil.centerProperties(this.titleFieldProperties, this.messageFieldProperties);
        this.cancelButtonProperties = new ButtonProperties(GameStyle.DIALOG_BUTTON_RED, CommonStyle.MODULE, new PIXI.Point(leftButtonX, 650));
        this.cancelButtonProperties.textFieldProperties = new TextFieldProperties(GameFontStyle.DIALOG_BUTTON_BIG);
        this.cancelButtonProperties.textFieldProperties.size = new PIXI.Point(360, 190);
        this.cancelButtonProperties.scale.set(0.9);
        this.confirmButtonProperties = new ButtonProperties(GameStyle.DIALOG_BUTTON_GREEN, CommonStyle.MODULE, new PIXI.Point(rightButtonX, 650));
        this.confirmButtonProperties.textFieldProperties = new TextFieldProperties(GameFontStyle.DIALOG_BUTTON_BIG);
        this.confirmButtonProperties.textFieldProperties.size = new PIXI.Point(360, 170);
        this.confirmButtonProperties.scale.set(0.9);
    }
}
//# sourceMappingURL=PromptDialogProperties.js.map